/* eslint-disable */
webpackJsonp([15,18,19],{

/***/ 										29:
	/***/ (function(module, exports) {

		// removed by extract-text-webpack-plugin

		/***/ }),

	/***/ 										63:
	/***/ (function(module, exports, __webpack_require__) {

		__webpack_require__(9);
		module.exports = __webpack_require__(29);


		/***/ }),

	/***/ 										9:
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";


		var _contentHero = __webpack_require__(3);

		var _contentHero2 = _interopRequireDefault(_contentHero);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		(0, _contentHero2.default)();

		/***/ })

},[63]);
/* eslint-enable */
